<template>
    <div>
        <div class="title">
            <i class="material-icons success">check_circle</i>
            <span></span>
        </div>
        
        <div class="dialog-second-content">
            <p>登入錯誤!</p>
        </div>

        <a href="/login"  @click="confirm">我知道了</a>
    </div>
</template>
<script>
export default {
    name:"modalTest",
    props:{
        params:{
        }
    },
    data(){
        return{
            info:this.params.firstInput,            
        }
    },
    created(){
    },
    methods:{
        confirm(){
            this.$emit("close",this.info);            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/LoginErrorModal.vue